import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { toServerFormatWithoutUTC } from 'core/classes/helpers/DateHelper'
import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import Logger from 'core/utils/Logger'
import { IPlanChangeLog } from 'partner360/models/planning/IPlanChangeLog'

interface IFetchPlanChangesLog {
  partnerId: string
  /** Sent for a reseller only: a distributor's log spans every offering. */
  programType: ProgramTypes | null
  fYear: number
  changeDate?: string
  isDistributor: boolean
  ownerId: string
}
export const fetchPlanChangesLog = async ({
  partnerId,
  changeDate,
  isDistributor,
  fYear,
  programType,
  ownerId,
}: IFetchPlanChangesLog): Promise<IPlanChangeLog[]> => {
  const url = proxy(`/webservice/197/sp/v4/spJBPPlanChangesLog/call`)
  if (fYear && partnerId && (programType || isDistributor)) {
    const payload = {
      'p.Fyear': fYear,
      'p.PartnerId': partnerId,
      'p.ProgramType': isDistributor ? null : programType,
      'p.ChangeDate': changeDate ? toServerFormatWithoutUTC(changeDate) : null,
    }

    const [accessToken] = getTokens(ownerId)
    const headers = new HttpHeaders()
    if (accessToken) {
      headers.add('Authorization', `Bearer ${accessToken}`)
    }

    try {
      const response = await Rest.post({ url, payload, headers })
      return response.Data
    } catch (e) {
      Logger.error(e)
      return []
    }
  }

  return []
}
